import CryptoproEsignModel from './cryptoproEsignModel';
import CryptoproEsignView from './cryptoproEsignView';

function CryptoproEsign(selector, options = {}) {
	this.cryptoproEsignModel = new CryptoproEsignModel();
	this.cryptoproEsignView = new CryptoproEsignView(selector, {
		hideDetailsCert: options.hideDetailsCert || false
	});
	this.waitDomLoad = options.waitDomLoad || false;
	this.onSelect = options.onSelect || null;

	this.handlerSelectCertChange = this.handlerSelectCertChange.bind(this);
	// this.init = this.init.bind(this);
}

CryptoproEsign.prototype.sign = function(dataSign, opt = {}) {
	var self = this;
	var needCallBack = !!opt.needCallBack;

	if(!this.cryptoproEsignModel.hasCertId()) {
		this.cryptoproEsignView.setValidationCertSelect(false);
		return;
	}

	var type = opt.type || 'string';
	var res = this.cryptoproEsignModel.Common_SignCadesBES(dataSign, type);
	var signature = null;

	
	console.log(res);
	res = res
		.then(function(data) {
			if(!data.success) {
				throw new Error(data.text);
			}

			if(needCallBack) {
				return Promise.resolve(data.signature);
			}

			return Promise.resolve(data);
		});

	if(needCallBack) {
		return res;
	}

	res = res
		.then(function(data) {
			self.cryptoproEsignView.setMessage(data.text, 'success');
			return data.signature;
		})
		.catch((e) => {
			self.cryptoproEsignView.setMessage(e, 'danger');
		});
	
	return res;
}

CryptoproEsign.prototype.signBase64 = function(dataSign, opt = {}) {
	var self = this;
	var needCallBack = !!opt.needCallBack;

	if(!this.cryptoproEsignModel.hasCertId()) {
		this.cryptoproEsignView.setValidationCertSelect(false);
		return;
	}

	var res = this.cryptoproEsignModel.SignCadesBES_Async_File(dataSign, true);
	var signature = null;

	res = res
		.then(function(data) {
			if(!data.success) {
				throw new Error(data.text);
			}

			if(needCallBack) {
				return Promise.resolve(data.signature);
			}

			return Promise.resolve(data);
		});

	if(needCallBack) {
		return res;
	}

	res = res
		.then(function(data) {
			self.cryptoproEsignView.setMessage(data.text, 'success');
			return data.signature;
		})
		.catch((e) => {
			self.cryptoproEsignView.setMessage(e, 'danger');
		});
	
	return res;
}

CryptoproEsign.prototype.signHash = function(hash, opt = {}) {
	var self = this;
	var needCallBack = !!opt.needCallBack;

	if(!this.cryptoproEsignModel.hasCertId()) {
		this.cryptoproEsignView.setValidationCertSelect(false);
		return;
	}

	var res = this.cryptoproEsignModel.SignHash(hash);
	var signature = null;

	res = res
		.then(function(data) {
			if(!data.success) {
				throw new Error(data.text);
			}

			if(needCallBack) {
				return Promise.resolve(data.signature);
			}

			return Promise.resolve(data);
		});

	if(needCallBack) {
		return res;
	}

	res = res
		.then(function(data) {
			self.cryptoproEsignView.setMessage(data.text, 'success');
			return data.signature;
		})
		.catch((e) => {
			self.cryptoproEsignView.setMessage(e, 'danger');
		});
	
	return res;
}

CryptoproEsign.prototype.coSignHash = function(sign, hash, data, opt = {}) {
	var self = this;
	var needCallBack = !!opt.needCallBack;

	if(!this.cryptoproEsignModel.hasCertId()) {
		this.cryptoproEsignView.setValidationCertSelect(false);
		return;
	}

	var res = this.cryptoproEsignModel.CoSignHash(sign, hash, data);
	var signature = null;

	res = res
		.then(function(data) {
			if(!data.success) {
				throw new Error(data.text);
			}

			if(needCallBack) {
				return Promise.resolve(data.signature);
			}

			return Promise.resolve(data);
		});

	if(needCallBack) {
		return res;
	}

	res = res
		.then(function(data) {
			self.cryptoproEsignView.setMessage(data.text, 'success');
			return data.signature;
		})
		.catch((e) => {
			self.cryptoproEsignView.setMessage(e, 'danger');
		});
	
	return res;
}


CryptoproEsign.prototype.handlerSelectCertChange = function(elSelect) {
	var self = this;
	
	this.cryptoproEsignView.setLoading(true);
	this.cryptoproEsignView.updateCertInfo(false);

	this.cryptoproEsignModel.onCertificateSelected(elSelect).then(function (data) {
		console.log(data);
		const errors = Object.entries(data).filter(([key, value]) => !value.success).map(([key, value]) => value.value);

		if(data) {
			self.cryptoproEsignView.setValidationCertSelect(true);
		}
		self.cryptoproEsignView.setLoading(false);
		self.cryptoproEsignView.updateCertInfo(data);
		if(self.onSelect) {
			// let subject = data.subject.split(', ');
			const d = Object.keys(data).reduce((acc, key) => {
				acc[key] = data[key].value;
				return acc;
			}, {});

			const parseSubject = d.subject.split(', ').reduce(function(acc, el) {
				var res = el.split('=');
				acc[res[0]] = res[1];
				return acc;
			}, {});

			self.onSelect({...d, subject: parseSubject}, errors);
		}
	});
}

CryptoproEsign.prototype.init = function() {

	new Promise((resolve, reject) => {
		return resolve(this.cryptoproEsignModel.Common_CheckForPlugIn)
	}).then((function(data) {
			this.cryptoproEsignView.updatePluginInfo(data);
		}).bind(this))

	return this.cryptoproEsignView.init(this.waitDomLoad)
		.then(function () {
			return cadesplugin;
		})
		.then(() => {
			this.cryptoproEsignView.setMessageCert('Загрузка сертификатов...');
			return this.cryptoproEsignModel.FillCertList_Async();
		})
		.then((function(data) {
			if(!data.length) {
				this.cryptoproEsignView.setMessageCert();
				return;
			}
			this.cryptoproEsignView.updateSelectCert(data);
			this.cryptoproEsignView.setHandlerSelect(this.handlerSelectCertChange);
		}).bind(this))
		.catch((function(e) {
			this.cryptoproEsignView.updatePluginInfo({
				statusCode: 'danger',
				statusText: e
			});
			throw new Error(e);
		}).bind(this))
}

CryptoproEsign.prototype.reset = function() {
	this.cryptoproEsignView.reset();
}



export default CryptoproEsign;
